import React from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import classNames from "classnames";
import "./checkbox.scss";
import { checkBoxOff, checkBoxOn } from "../images";

export const CustomCheckbox = ({
  label,
  checked = false,
  className,
  ...props
}) => {
  return (
    <FormControlLabel
      className={classNames("checkbox-wrapper", className)}
      control={
        <Checkbox
          icon={checkBoxOff}
          checkedIcon={checkBoxOn}
          checked={checked}
          disableRipple
        />
      }
      label={label}
      {...props}
    />
  );
};
